module.exports = __webpack_public_path__ + "img/protocols_4_4.63fa788b.png";